
import { ApiBase } from "@/core/api";
import { defineComponent, ref, onBeforeMount } from "vue";
import { useI18n } from "vue-i18n";
import _ from "lodash";

interface Filter {
  order_number: string;
  customer_id: string;
  order_type: string;
  distribution_model: string;
  order_status: string;
  status: string;
  created_at_start: string;
  created_at_end: string;
}

export default defineComponent({
  name: "filter-sales-invoice-dropdown",
  components: {},
  emits: ["submit-filter", "reset-filter"],
  setup(props, { emit }) {
    const { t } = useI18n();

    const formRef = ref<null | HTMLFormElement>(null);

    const formData = ref<Filter>({
      order_number: "",
      customer_id: "",
      order_type: "",
      distribution_model: "",
      order_status: "",
      status: "",
      created_at_start: "",
      created_at_end: "",
    });

    const options = ref({
      customer: [],
      customerLoading: false,
      type: [
        {
          label: t("quickSettlement.typeSale"),
          value: 1,
        },
        {
          label: t("quickSettlement.typeDeposit"),
          value: 2,
        },
      ],
      distribution_model: [
        {
          label: t("quickSettlement.distributionModelGrossProfitMode"),
          value: 1,
        },
        {
          label: t("quickSettlement.distributionModelTransactionMode"),
          value: 2,
        },
      ],
      order_status: [
        {
          label: t("quickSettlement.orderStatusNew"),
          value: 1,
        },
        {
          label: t("quickSettlement.orderStatusProcessed"),
          value: 2,
        },
        {
          label: t("quickSettlement.orderStatusVoid"),
          value: 3,
        },
      ],
      payment_status: [
        {
          label: t("quickSettlement.paymentStatusPending"),
          value: 1,
        },
        {
          label: t("quickSettlement.paymentStatusPaid"),
          value: 2,
        },
      ],
    });

    const getCustomerOptions = async (query: string) => {
      options.value.customerLoading = true;
      const { data } = await ApiBase.getCustomerSourceData({ name: query });
      options.value.customerLoading = false;
      if (data.code == 0) {
        options.value.customer = data.data;
      }
    };

    const debounceCustomerSearch = _.debounce(getCustomerOptions, 1000);

    const searchCustomerItems = (query: string) => {
      debounceCustomerSearch(query);
    };

    const getTaggingData = async () => {
      const { data } = await ApiBase.getTaggingData({
        short_key: ["sales_order_distribution_mode"],
      });
      if (data.code == 0) {
        options.value.distribution_model =
          data.data.sales_order_distribution_mode.items;
      }
    };

    const getFromInfo = () => {
      // loading.value = true;
      Promise.all([])
        .then(() => {
          // loading.value = false;
        })
        .catch((error) => {
          console.log(error);
        });
    };

    const submit = () => {
      emit("submit-filter", formData.value);
    };

    const handleReset = () => {
      formRef.value?.resetFields();
      emit("reset-filter");
    };

    onBeforeMount(() => {
      getFromInfo();
    });

    return {
      t,
      formData,
      formRef,
      submit,
      handleReset,
      options,
      searchCustomerItems,
    };
  },
});
